<template>
  <div class="downLoad-container">

    <el-dialog
      title="文件下载"
      :visible.sync="progressModal"
      width="30%"
      @closed='percent=0'
    >
      <div class="pack-content">
        <p>正在为您打包,请耐心等待...</p>
      </div>
      <el-progress
        :percentage=percent
        :stroke-width="5"
      ></el-progress>
    </el-dialog>
    <el-dialog :visible.sync="ifBoxshow" class="downLoadBox" :before-close="handleClose" >
      <div style="margin:0 auto;">
        {{isGaonS?isEnglish?"Select image size:":"选择图片尺寸：":"选择图片尺寸："}}
        <el-radio-group v-model="downLoadSize" size="medium">
          <el-radio-button label="M"></el-radio-button>
          <el-radio-button label="L"></el-radio-button>
          <el-radio-button :label="isGaonS?isEnglish?'Original':'原图':'原图'"></el-radio-button>
        </el-radio-group>
      </div>
      <p v-if="isGaonS&&isEnglish" style="height:40px;line-height:40px;text-align:center;">{{downLoadSize=="M"?"Size:The long side is 800":downLoadSize=="L"?"Size:The long side is 1024":""}}</p>
      <p v-else style="height:40px;line-height:40px;text-align:center;">{{downLoadSize=="M"?"规格:长边为800":downLoadSize=="L"?"规格:长边为1024":""}}</p>
      <div style="margin:0 auto;text-align:center;">
        <el-button size="small" @click="ifBoxshow = false">{{isGaonS?isEnglish?"Cancel":"取 消":"取 消"}}</el-button>
        <el-button size="small" type="primary" @click="packageDownload(get_load,get_group_id,downLoadSize)">{{isGaonS?isEnglish?"Confirm download":"确认下载":"确认下载"}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  downloadAttachment,
  allDownload,
  getImageBlob
} from "@/services/api.js";
export default {
  name: "loadResource",
  data() {
    return {
      percent: 0,
      progressModal: false,
      get_load:'',
      get_group_id:'',
      ifBoxshow:false,
      downLoadSize:"M",
    };
  },

  methods: {
    handleClose(done) {
       done();
    },
    // 传参(选中项的id) ////原是下面的下载 现加弹窗
    downloadFn(load, group_id) {
      this.get_load = load;
      this.get_group_id = group_id;
      this.ifBoxshow = true;
    },
    //组图下载加弹窗选择尺寸 ===== 上面的downloadFn负责弹出框，我负责get资源
    packageDownload(load, group_id, size) {
      let picsize = "";
      if(size=="M"){
        picsize = 800;
      }else if(size=="L"){
        picsize = 1024;
      }else{
        picsize = "";
      }
      if (Array.isArray(load)) {
        // if (load.length === 1) {
        //   this.singleLoadFn({ assetId: load[0] });
        // } else {
          if (group_id) {
            this.packLoadFn({ assetIds: load.toString(), groupId: group_id ,size: picsize});
          } else {
            this.packLoadFn({ assetIds: load.toString() ,size: picsize});
          }
        // }
      } else {
        console.error("只接收数组");
      }
      this.ifBoxshow = false;
    },
    // 点击单张下载
    singleLoadFn(single) {
      this.handleSpinCustom();
      singleLoad(single).then(res => {
        if (res.status_code === 1) {
          let a = document.createElement("a");
          a.href = res.data.url;
          a.download = new Date().getTime() + "." + res.data.mime_type;
          a.click();
          // getImageBlob(res.data.url).then(res => {
          //   this.downloadLocation(res);
          // });
        } else {
          this.$Message.error(res.message.message);
        }
      });
    },
    // 单张下载
    downloadLocation(blob) {
      const fileName = new Date().getTime();
      const nb = new Blob([blob], { type: blob.type });
      const url = URL.createObjectURL(nb);
      const atDom = document.createElement("a");
      atDom.setAttribute("href", url);
      atDom.download = fileName + "." + blob.type.split("/")[1];
      // document.body.appendChild(atDom)
      atDom.click();
      // setTimeout(() => {
      //   document.body.removeChild(atDom)
      // }, 200)
      this.$Spin.hide();
    },
    // 多张下载
    packLoadFn(pack) {
      // 动画
      this.progressModal = true;
      var self = this;
      var timer = setInterval(function() {
        self.percent += 1;
        if (self.percent == 97) {
          clearInterval(timer);
        }
        if(self.percent > 97){
          self.percent = 97
        }
      }, 100);
      
      allDownload(pack).then(res => {
        if (res.status_code === 1) {
          self.percent = 100;
          self.progressModal = false;
          self.handleSpinCustom();
          self.downloadFiles(res.data);
          self.percent = 0;
        } else {
          self.percent = 0;
          self.progressModal = false;
          self.$Message.error(res.message);
        }
      });
    },
    // 压缩包下载
    downloadFiles(href) {
      const fileName = new Date().getTime();
      const link = document.createElement("a");
      link.display = "none";
      link.download = fileName;
      link.href = href;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 200);
      this.$Spin.hide();
    },
    handleSpinCustom(msg) {
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", msg ? msg + "..." : "正在为您下载中...")
          ]);
        }
      });
    }
  },
  computed:{
    ...mapGetters([
      "isGaonS","isEnglish"
    ]),
  }
};
</script>

<style lang="less">
// .downLoad-container{
.progress-modal {
  .ivu-modal-content {
    .ivu-modal-close {
      display: none;
    }
    .packTitle {
      font-size: 18px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ccc;
    }
    .pack-content {
      padding: 20px 10px;
      text-align: center;
      font-size: 16px;
    }
    .ivu-modal-footer {
      display: none;
    }
  }
}
// }
.downLoadBox .el-dialog{
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/loadResource.vue